/* BEAT theme — interactions (no dependencies) */
(function () {
  'use strict';
  var root = document.documentElement;
  var R = (window.BEAT && window.BEAT.routes) || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };
  var S = (window.BEAT && window.BEAT.strings) || { adding: 'Adding…', addError: 'Could not add to cart. Try again.', updateError: 'Could not update cart.', openCartOne: 'Open cart, __N__ item', openCartOther: 'Open cart, __N__ items' };

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- Reveal on scroll (framer-motion rise + stagger) ---------- */
  function initReveal(scope) {
    $$('[data-reveal]', scope).forEach(function (group) {
      $$('[data-rise]', group).forEach(function (el, i) {
        el.style.transitionDelay = (50 + i * 80) + 'ms';
      });
    });
    var targets = $$('[data-reveal], [data-fade-up], [data-zoom-in]', scope);
    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -80px 0px', threshold: 0.01 });
    targets.forEach(function (el) {
      if (el.hasAttribute('data-reveal-now')) {
        requestAnimationFrame(function () { el.classList.add('is-visible'); });
      } else {
        io.observe(el);
      }
    });
  }

  /* ---------- Hero load-in ---------- */
  function initHero() {
    $$('[data-hero]').forEach(function (hero) {
      var img = $('.hero__media', hero);
      var go = function () { hero.classList.add('is-loaded'); };
      if (!img || img.complete) requestAnimationFrame(go);
      else { img.addEventListener('load', go); img.addEventListener('error', go); setTimeout(go, 1500); }
    });
  }

  /* ---------- Header: scrolled state ---------- */
  function initHeader() {
    var header = $('[data-header]');
    if (!header) return;
    var menu = $('[data-menu]');
    var onScroll = function () {
      var open = menu && menu.classList.contains('is-open');
      header.classList.toggle('is-scrolled', window.scrollY > 40 && !open);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    $$('[data-scroll-top]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });
  }

  /* ---------- Menu overlay ---------- */
  function initMenu() {
    var menu = $('[data-menu]');
    if (!menu) return;
    var opener = $('[data-menu-open]');
    var lastFocus = null;
    function open() {
      lastFocus = document.activeElement;
      menu.classList.add('is-open');
      document.body.classList.add('is-locked');
      if (opener) opener.setAttribute('aria-expanded', 'true');
      var close = $('[data-menu-close]', menu);
      if (close) close.focus();
    }
    function close(restore) {
      menu.classList.remove('is-open');
      document.body.classList.remove('is-locked');
      if (opener) opener.setAttribute('aria-expanded', 'false');
      if (restore !== false && lastFocus) lastFocus.focus();
    }
    if (opener) opener.addEventListener('click', open);
    $$('[data-menu-close]', menu).forEach(function (b) { b.addEventListener('click', function () { close(); }); });
    $$('.menu__nav a', menu).forEach(function (a) {
      a.addEventListener('click', function (e) {
        var href = a.getAttribute('href') || '';
        var hashIndex = href.indexOf('#');
        var path = hashIndex >= 0 ? href.slice(0, hashIndex) : href;
        var samePage = hashIndex >= 0 && (path === '' || path === '/' || path.replace(/\/$/, '') === window.location.pathname.replace(/\/$/, ''));
        if (samePage) {
          var target = document.getElementById(href.slice(hashIndex + 1));
          if (target) {
            e.preventDefault();
            close(false);
            setTimeout(function () { target.scrollIntoView({ behavior: 'smooth' }); }, 260);
            return;
          }
        }
        close(false);
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) close();
    });
  }

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (!step) return;
    var wrap = step.closest('[data-qty]');
    var input = wrap && $('input', wrap);
    if (!input) return;
    var min = parseInt(input.min || '0', 10);
    var next = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-qty-step'), 10));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product gallery ---------- */
  function initGallery() {
    $$('[data-gallery]').forEach(function (g) {
      var main = $('.pdp__main img', g);
      $$('[data-gallery-thumb]', g).forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (main) { main.removeAttribute('srcset'); main.src = btn.getAttribute('data-src'); }
          $$('[data-gallery-thumb]', g).forEach(function (b) { b.setAttribute('aria-current', b === btn ? 'true' : 'false'); });
        });
      });
    });
  }

  /* ---------- Purchase options (subscriptions) ---------- */
  function initPlans() {
    $$('[data-plans]').forEach(function (fieldset) {
      var form = fieldset.closest('form');
      var hidden = $('[data-selling-plan]', form);
      var buy = fieldset.closest('.pdp__buy') || document;
      var priceEl = $('[data-price]', buy);
      var perEl = $('[data-per]', buy);
      var compareEl = $('[data-compare]', buy);
      var radios = $$('input[name="beat_purchase"]', fieldset);
      var selects = $$('[data-plan-select]', fieldset);

      function apply() {
        var checked = radios.filter(function (r) { return r.checked; })[0];
        if (!checked) return;
        var planId = checked.value;
        var price = checked.getAttribute('data-price');
        var per = checked.getAttribute('data-per');
        var group = checked.getAttribute('data-group');
        selects.forEach(function (s) {
          var active = group && s.getAttribute('data-plan-select') === group;
          s.hidden = !active;
          if (active) {
            var opt = s.options[s.selectedIndex];
            planId = s.value;
            price = opt.getAttribute('data-price');
            per = opt.getAttribute('data-per');
          }
        });
        if (hidden) hidden.value = planId || '';
        if (priceEl && price) priceEl.textContent = price;
        if (perEl && per) perEl.textContent = per;
        if (compareEl) compareEl.hidden = Boolean(planId);
      }
      radios.forEach(function (r) { r.addEventListener('change', apply); });
      selects.forEach(function (s) { s.addEventListener('change', apply); });
      apply();
    });
  }

  /* ---------- Cart (AJAX + drawer) ---------- */
  var drawerSection = 'cart-drawer';

  function openCart() {
    root.classList.add('cart-open');
    document.body.classList.add('is-locked');
    var d = $('[data-drawer]');
    if (d) setTimeout(function () { d.focus(); }, 50);
  }
  function closeCart() {
    root.classList.remove('cart-open');
    var menu = $('[data-menu]');
    if (!menu || !menu.classList.contains('is-open')) document.body.classList.remove('is-locked');
  }

  function replaceSection(id, html) {
    if (!html) return;
    var holder = document.getElementById('shopify-section-' + id);
    if (!holder) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById('shopify-section-' + id);
    holder.innerHTML = fresh ? fresh.innerHTML : html;
  }

  function updateCount() {
    var d = $('[data-drawer]');
    var count = d ? parseInt(d.getAttribute('data-count') || '0', 10) : 0;
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
    $$('[data-cart-open]').forEach(function (el) {
      el.setAttribute('aria-label', (count === 1 ? S.openCartOne : S.openCartOther).replace('__N__', count));
    });
  }

  function sectionsToFetch() {
    var ids = [drawerSection];
    var page = $('[data-cart-page]');
    if (page) ids.push(page.getAttribute('data-section'));
    return ids;
  }

  function renderSections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) { replaceSection(id, sections[id]); });
    updateCount();
  }

  // Add to cart
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[data-ajax-cart]')) return;
    if (!window.fetch || !window.FormData) return;
    e.preventDefault();
    var btn = $('[type="submit"]', form);
    var label = btn ? btn.getAttribute('data-add-label') || btn.textContent : '';
    var err = $('[data-form-error]', form);
    if (btn) { btn.disabled = true; btn.textContent = S.adding; }
    if (err) err.hidden = true;
    var data = new FormData(form);
    if (data.get('selling_plan') === '') data.delete('selling_plan');
    data.delete('beat_purchase');
    data.append('sections', sectionsToFetch().join(','));
    data.append('sections_url', window.location.pathname);
    fetch(R.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: data })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok || res.body.status) {
          var msg = res.body.description || res.body.message || S.addError;
          if (err) { err.textContent = msg; err.hidden = false; } else { window.alert(msg); }
          return;
        }
        renderSections(res.body.sections);
        openCart();
      })
      .catch(function () { form.removeAttribute('data-ajax-cart'); form.submit(); })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
  });

  // Change line quantity
  function changeLine(lineEl, qty) {
    var list = lineEl.closest('[data-lines]');
    var scope = lineEl.closest('.drawer, [data-cart-page]') || document.body;
    scope.classList.add('is-busy');
    fetch(R.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: parseInt(lineEl.getAttribute('data-line'), 10), quantity: qty, sections: sectionsToFetch(), sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (body) {
        if (body.status) { window.alert(body.description || body.message || S.updateError); }
        renderSections(body.sections);
      })
      .catch(function () { window.location.href = R.cart; })
      .finally(function () { scope.classList.remove('is-busy'); });
    return list;
  }

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-qty]');
    if (!input) return;
    var line = input.closest('[data-line]');
    if (!line) return;
    clearTimeout(input._t);
    input._t = setTimeout(function () { changeLine(line, Math.max(0, parseInt(input.value, 10) || 0)); }, 250);
  });

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-line-remove]');
    if (rm) {
      var line = rm.closest('[data-line]');
      if (line && window.fetch) { e.preventDefault(); changeLine(line, 0); }
      return;
    }
    var opener = e.target.closest('[data-cart-open]');
    if (opener && $('[data-drawer]')) {
      e.preventDefault();
      openCart();
      return;
    }
    if (e.target.closest('[data-cart-close]')) closeCart();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('cart-open')) closeCart();
  });

  /* ---------- Contact form success (only the form that was posted) ---------- */
  function initFormSuccess() {
    var posted = /[?&]contact_posted=true/.test(window.location.search);
    var hash = window.location.hash.replace('#', '');
    $$('[data-success]').forEach(function (msg) {
      var form = msg.closest('form');
      if (!posted || !form) return;
      var mine = hash ? form.id === hash : false;
      if (!hash) {
        // Shopify sometimes drops the hash: fall back to the first success message on the page
        mine = msg === $('[data-success]');
      }
      if (mine) {
        msg.hidden = false;
        var fields = $('[data-fields]', form);
        if (fields) fields.hidden = true;
      }
    });
  }


  /* ---------- Hero rotating word ---------- */
  function initRotator() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    $$('[data-rotator]').forEach(function (el) {
      var words;
      try { words = JSON.parse(el.getAttribute('data-rotator')); } catch (e) { return; }
      if (!words || words.length < 2 || reduce) return;
      var word = $('.rotator__word', el);
      var i = 0;
      setInterval(function () {
        if (document.hidden) return;
        word.classList.add('is-out');
        setTimeout(function () {
          i = (i + 1) % words.length;
          word.textContent = words[i];
          word.classList.remove('is-out');
          word.classList.add('is-in');
          void word.offsetWidth;
          word.classList.remove('is-in');
        }, 450);
      }, 2600);
    });
  }

  /* ---------- Boot ---------- */
  function boot() {
    initHero();
    initRotator();
    initReveal(document);
    initHeader();
    initMenu();
    initGallery();
    initPlans();
    initFormSuccess();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
